import MaskedField from "../../BaseInputFields/MaskedField/MaskedField";
import {
  FieldLabeledProps,
  SocialSecurityNumberV2Props,
} from "../../types/fieldTypes";
import { formatSSNSensitiveHidden } from "./utils";

export interface SocialSecurityNumberV2FieldProps
  extends SocialSecurityNumberV2Props {
  labelProps?: FieldLabeledProps;
  disableToolTip?: boolean;
  alwaysAllowSensitiveToggle?: boolean;
}

export const SocialSecurityNumberV2Field: React.FC<
  SocialSecurityNumberV2FieldProps
> = ({
  labelProps,
  label,
  description,
  value,
  disabled,
  onSubmit,
  hidden,
  errorMessages,
  isRequired,
  disableToolTip,
  alwaysAllowSensitiveToggle,
  defaultToSensitiveHidden = true,
}) => {
  return (
    <MaskedField
      type="Text"
      label={label}
      labelProps={labelProps}
      description={description}
      value={value}
      disabled={disabled}
      onSubmit={onSubmit}
      hidden={hidden}
      errorMessages={errorMessages}
      isRequired={isRequired}
      placeholder="123-45-6789"
      mask="[0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9][0-9][0-9]"
      isSensitive={true}
      defaultToSensitiveHidden={defaultToSensitiveHidden}
      alwaysAllowSensitiveToggle={alwaysAllowSensitiveToggle}
      sensitiveHiddenFormatter={formatSSNSensitiveHidden}
      disableToolTip={disableToolTip}
      cursorPositionOnFocus="start"
    />
  );
};

export default SocialSecurityNumberV2Field;
